import { MapboxMap } from 'react-map-gl';

import { GeoPoint, MarketShape } from './types';

export const getBoundsFromShape = (shape: MarketShape): [[number, number], [number, number]] => {
  const { type, coordinates } = shape;

  if (!Array.isArray(coordinates)) {
    throw new Error('MarketShape coordinates must be a valid array');
  }

  let polygons;
  if (type === 'Polygon') {
    polygons = coordinates[0];
  } else if (type === 'MultiPolygon') {
    polygons = coordinates.flat(2);
  } else {
    polygons = null;
  }

  if (!Array.isArray(polygons) || polygons.length === 0) {
    throw new Error(
      type === 'Polygon' || type === 'MultiPolygon'
        ? 'Invalid polygon coordinates'
        : `Unsupported GeoJSON shape type: ${type}`,
    );
  }

  const lngs = polygons.map((coord) => coord.lon);
  const lats = polygons.map((coord) => coord.lat);

  return [
    [Math.min(...lngs), Math.min(...lats)],
    [Math.max(...lngs), Math.max(...lats)],
  ];
};

export const getShapeFromMap = (map: MapboxMap): GeoPoint[] => {
  const bounds = map.getBounds();
  const vertices = [
    { lon: bounds.getNorthWest().lng, lat: bounds.getNorthWest().lat },
    { lon: bounds.getNorthEast().lng, lat: bounds.getNorthEast().lat },
    { lon: bounds.getSouthEast().lng, lat: bounds.getSouthEast().lat },
    { lon: bounds.getSouthWest().lng, lat: bounds.getSouthWest().lat },
    // The first and last points of a polygon must be identical
    { lon: bounds.getNorthWest().lng, lat: bounds.getNorthWest().lat },
  ];
  return vertices;
};
